import { useRouter, ErrorComponentProps } from '@tanstack/react-router'
import { ErrorFallbackUI } from './ErrorFallbackUI'

export function ErrorBoundary({ error }: ErrorComponentProps) {
    const router = useRouter()

    const handleGoHome = () => {
        router.navigate({ to: '/' })
    }

    const handleGoBack = () => {
        window.history.back()
    }

    const handleRetry = () => {
        window.location.reload()
    }

    return (
        <ErrorFallbackUI
            error={error}
            onRetry={handleRetry}
            onGoHome={handleGoHome}
            onGoBack={handleGoBack}
        />
    )
}
